<template>
  <div class="page-header">
    <page-title :step="step" />
    <progress-bar :step="step" />
  </div>
</template>
<script>
import PageTitle from "./PageTitle.vue";
import ProgressBar from "./ProgressBar.vue";

export default {
  name: "AppHeader",
  props: {
    step: {
      type: Number,
      required: true,
    },
  },
  components: {
    PageTitle,
    ProgressBar,
  },
};
</script>
